import styled from "@emotion/styled";
import loader from "src/assets/images/loader.gif";
import { i18n, mediaQuery } from "src/common";
import { Flex } from "src/components";
import { footer, header } from "src/theme";


const LoaderStyle = styled.img((props: { size: number }) => ({
  width: props.size,
  height: props.size,
}));

const FlexStyle = styled(Flex)<{ page: boolean; overlay: boolean }>`
  ${({ page, overlay }) => overlay ? `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 1000;
  ` : `
    min-height: ${page ? `calc(100vh - ${footer.mobileHeight + header.mobileHeight + 80}px)` : 'auto'};
    @media ${mediaQuery('mobile')} {
      min-height: ${page ? `calc(100vh - ${footer.height + header.mobileHeight + 80}px)` : 'auto'};
    }
    @media ${mediaQuery('laptopL')} {
      min-height: ${page ? `calc(100vh - ${footer.height + header.height + 80}px)` : 'auto'};
    }
  `}
`;

interface LoaderProps {
  size?: number;
  page?: boolean;
  loading?: boolean;
  overlay?: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ 
  size = 24, 
  page = false, 
  loading = true,
  overlay = false,
}) => (
  loading ? (
    <FlexStyle 
      justify="center" 
      align="center" 
      page={page}
      overlay={overlay}
    >
      <LoaderStyle src={loader} alt={i18n.t('common.loading')} size={size} />
    </FlexStyle>
  ) : null
)